const RECENT_LOCATIONS_KEY = 'recentLocations';
const MAX_RECENTS =1;

import { types as sdkTypes } from 'sharetribe-flex-sdk';
const { LatLng, LatLngBounds } = sdkTypes;


const sharetribeLocation = (place) => {
  try {
    const location = place?.location;
    if (!location || !location?.origin || !location?.bounds) {
      throw new Error('Incomplete location data');
    }
    return {
      address: location.address,
      origin: new LatLng(location.origin.lat, location.origin.lng),
     ...(location?.bounds?.sw && location?.bounds?.sw?.lat && location?.bounds?.ne && location?.bounds?.ne?.lat ? { bounds: new LatLngBounds(
        new LatLng(location.bounds.ne.lat, location.bounds.ne.lng),
        new LatLng(location.bounds.sw.lat, location.bounds.sw.lng),
      ),} : null)
    };
  } catch (e) {
    console.error('Error constructing sharetribeLocation:', e, place);
    return null; // or fallback object
  }
};

export const getRecentLocations = () => {
  try {
    const data = localStorage.getItem(RECENT_LOCATIONS_KEY);
    if (!data) return [];

    let parsed;
    try {
      parsed = JSON.parse(data);
    } catch (parseError) {
      console.error('JSON parse error from localStorage:', parseError);
      return [];
    }

    return parsed
      .map((st) => {
        const location = sharetribeLocation(st);
        if (!location) return null;
        return { label: st.label, location };
      })
      .filter(Boolean); // remove nulls if any

  } catch (e) {
    console.error('Failed to get recent locations:', e);
    return [];
  }
};

export const saveRecentLocation = location => {  
  if (!location) return;  
  const label = location?.address;
  if (!label) return;

  const entry = {
    label,
    location,
  }; 
  const recents = getRecentLocations().filter(l => l.label !== label);
  const updated = [entry, ...recents].slice(0, MAX_RECENTS); 
  localStorage.setItem(RECENT_LOCATIONS_KEY, JSON.stringify(updated));
};

